
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Gofragt.dk
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Danmarks førende kurer service med fokus på hurtige, sikre og pålidelige leveringer. 
              Vi er din partner for alle leveringsbehov.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Tjenester</h4>
            <ul className="space-y-2">
              <li><a href="#tjenester" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Samme-dag Levering</a></li>
              <li><a href="#tjenester" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Ekspres Transport</a></li>
              <li><a href="#tjenester" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Sikre Leveringer</a></li>
              <li><a href="#tjenester" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Erhvervslevering</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Kontakt</h4>
            <div className="flex items-center mb-3">
                <i className="ri-phone-line text-teal-400 mr-3"></i>
                <div>
                  <span className="text-white">+45 21 56 35 52</span>
                  <p className="text-gray-400 text-sm">Åben 24 timer i døgnet</p>
                </div>
              </div>
            <ul className="space-y-2">
              <li className="text-gray-300">
                <i className="ri-mail-line mr-2"></i>
                mikkelrisum@hotmail.dk
              </li>
              <li className="text-gray-300">
                <i className="ri-map-pin-line mr-2"></i>
                Silkeborgvej 26A, 8000 Århus C
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Gofragt.dk. Alle rettigheder forbeholdes.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Privatlivspolitik</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Handelsbetingelser</a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}